import Main from "../components/Main";
import Login from "../components/Login";
import Error from "../components/Error";
import Register from "../components/Register";
import { Navigate } from 'react-router-dom';
import Menu from "../components/Menu";
import Container from "../components/Main/Container";
import Customer from "../components/Main/Customer";
import Inventory from "../components/Main/Inventory";
import Statistics from "../components/Main/Statistics";
import Goods from "../components/Main/Goods";
import Basket from "../components/Main/Basket";
import OrderHistory from "../components/Main/Inventory/OrderHistory";
import BasketHistory from "../components/Main/Basket/History";
import Attribute from "../components/Main/Attribute";
const routes = [
  {
    path: '/main',
    element: <Main />,
    children: [
      {
        path: 'customer',
        element: <Customer />
      },
      {
        path: 'container',
        element: <Container />
      },{
        path: 'attribute',
        element: <Attribute />
      },{
        path: 'inventory',
        element: <Inventory />
      }, {
        path: 'statistics',
        element: <Statistics />
      }, {
        path: 'basket',
        element: <Basket />
      }, {
        path: 'goods',
        element: <Goods />
      }, {
        path: 'orderhistory',
        element: <OrderHistory />
      }, {
        path: 'baskethistory',
        element: <BasketHistory />
      }
      
    ]
  },
  {
    path: '/login',
    element: <Login />
  },
  {
    path: '/error',
    element: <Error />
  },
  {
    path: '/register',
    element: <Register />
  },
  {
    path: '/menu',
    element: <Menu />
  },
  {
    path: '*',
    element: <Navigate to="/login" />
  }
]

export default routes